<template>
  <div>
    <van-nav-bar
      title="取消出入库"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      fixed
    />
    <div class="psiConfirmCont">
      <div style="display: flex;">
        <van-field-acb
          class="fieldLi"
          v-model="cancelType"
          dict="dict_barcode_cancel_type"
          label="类型"
          on-change=""
        >
        </van-field-acb>
      </div>
      <div style="display: flex;">
        <van-field
          v-model="value"
          center
          clearable
          label="条码"
          ref="barcodeInput"
          placeholder="请输入条码"
        >
          <template #button>
            <van-button size="small" type="info" @click="confirm"
              >确定</van-button
            >
          </template>
        </van-field>
      </div>
      <div class="psiDetailCont">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            finished-text="没有更多了"
          >
            <div v-for="item in list" class="card" :key="item.uuid">
              <template>
                <table class="layout">
                  <tr>
                    <td>{{ item.barcode }}</td>
                    <td colspan="2">{{ item.statusname }}</td>
                  </tr>
                  <tr v-for="obj in item.details" :key="obj.field1">
                    <td>{{obj.field1}}</td>
                    <td>{{obj.field2}}</td>
                    <td>{{obj.field3}}</td>
                  </tr>
                </table>
              </template>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar, Field, Button, List, PullRefresh, Toast } from "vant";
import VanFieldAcb from '../../components/VanFieldAcb';
import barcodeService from "../../service/barcodeService";
import { formatDictionary } from "../../utils/dictionary";
import moment from "moment";

export default {
  data() {
    return {
      cancelType: "1",
      value: "",
      tempCancelType: "1",
      tempValue: "",
      quantity: 0,
      barcodeIds: ["0"],
      list: [],
      loading: false,
      finished: false,
      pageIndex: 0,
      refreshing: false,
      fields:[],
      dictNames: ""
    };
  },
  mounted: async function() {
    this.$refs.barcodeInput.focus();
    let that = this;
    document.onkeydown = function(event) {
      if (event.keyCode == 13) {
        that.tempCancelType = that.cancelType;
        that.tempValue = that.value;
        if(that.tempCancelType.length === 0 ||
                (that.tempCancelType != "1" && that.tempCancelType != "2")){
          return;
        }
        if (that.value.length == 0) {
          that.$refs.barcodeInput.focus();
        } else {
          that.confirm();
        }
      }
    };
  },
  components: {
    VanFieldAcb,
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [VanFieldAcb.name]: VanFieldAcb,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    async confirm() {
      let resp = await barcodeService.cancelStatus(this.value, this.cancelType);
      if (resp.data.Status === "1") {
        this.barcodeIds.push(resp.data.Data);
        Toast.success("取消成功");
        this.value = "";
        this.$refs.barcodeInput.focus();
        this.onRefresh();
      } else {
        Toast.fail(resp.data.Data);
        this.value = "";
        this.$refs.barcodeInput.focus();
      }
    },
    async onLoad() {
      if(this.dictNames == ""){
        let resp = await barcodeService.getBarcodeFieldList();
        if (resp.data.Status == "1") {
          this.fields = resp.data.Data;
          if(this.fields.length > 0){
            let tempDict = "position.rad_position";
            this.fields.forEach(item => {
              if(item.type == "6"){
                tempDict += ",";
                tempDict += item.name;
                tempDict+= ".";
                tempDict += item.dictName;
              }
            });
            tempDict += ",";
            tempDict += "status";
            tempDict+= ".";
            tempDict += "rad_barcode_status";
            this.dictNames = tempDict;
          }else{
            this.dictNames = "radId.rad_sku,radCategory.rad_sku_category,centerCategory.dict_rad_center_category,caliber.dict_rad_caliber,color.dict_rad_color,waterFlow.dict_rad_flowin_method,position.rad_position";
          }
        }
      }
      this.pageIndex++;
      let resp = await barcodeService.getInputList(
        this.pageIndex,
        this.barcodeIds.join(","),
        this.dictNames
      );
      resp.data.Data.data.forEach(item => {
        item.inputTime = moment(item.inputTime).format("YYYY-MM-DD");
      });
      formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      resp.data.Data.data.forEach(item => {
        let details = [];
        if(this.fields.length > 0){
          let length = this.fields.length;
          let detailItem = {};
          this.fields.forEach(function (obj, i) {
            if(obj.name == "pieces"){
              item[obj.name] = (item[obj.name] || "") + "片";
            }
            if(i%3 == 0){
              detailItem = {};
              if(obj.type == "6"){
                detailItem.field1 = item[obj.name+"name"] || "";
              }else{
                detailItem.field1 = item[obj.name] || "";
              }
              if(i == length -1){
                details.push(detailItem);
              }
            }
            if(i%3 == 1){
              if(obj.type == "6"){
                detailItem.field2 = item[obj.name+"name"] || "";
              }else{
                detailItem.field2 = item[obj.name] || "";
              }
              if(i == length -1){
                details.push(detailItem);
              }
            }
            if(i%3 == 2){
              if(obj.type == "6"){
                detailItem.field3 = item[obj.name+"name"] || "";
              }else{
                detailItem.field3 = item[obj.name] || "";
              }
              details.push(detailItem);
            }
          });
        }else{
          details.push({
            field1: item.radCategoryname,
            field2: item.radIdname,
            field3: item.pieces + "片"
          });
          details.push({
            field1: item.centerCategoryname,
            field2: item.centerSpacing,
            field3: item.calibername
          });
          details.push({
            field1: item.colorname,
            field2: item.waterFlowname,
            field3: item.isSpecials || ""
          });
        }
        item.details = details;
      });
      this.loading = false;
      this.refreshing = false;
      this.list = [...this.list, ...resp.data.Data.data];
      this.finished = resp.data.Data.total <= this.list.length;
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    }
  },
  watch: {
    async cancelType() {
      this.value = "";
      this.barcodeIds = ["0"];
      this.onRefresh();
    }
  }
};
</script>

<style scoped>
.psiConfirmCont {
  width: 100%;
  margin: 0 auto;
  margin-top: 120px;
  overflow: hidden;
}

.fieldLi .van-cell__title {
  text-align: left !important;
}
.fieldLi .van-cell__value input {
  text-align: right !important;
}
.fieldLi .van-cell__value textarea {
  text-align: right !important;
}

.psiDetailCont {
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;
}
</style>
